"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createContainerSchema = createContainerSchema;
const zod_1 = require("zod");
function createContainerSchema(translations) {
    const required = translations.fieldRequired('title');
    return zod_1.z.object({
        title: zod_1.z
            .string({ error: () => required })
            .min(1, required)
            .max(140, translations.maxCharsN(140, 'title')),
    });
}
//# sourceMappingURL=container.js.map